function translateAPIError(error) {

  if (   !error
      || !error.response
      || !error.response.data
      || !error.response.data.msg)
  {
    return("I18N_ERR_General_System_Err");
  } else {
    if (!error.response.data.msg.startsWith("ERR_"))
      return("I18N_ERR_General_System_Err");
    else
      return("I18N_" + error.response.data.msg);
  }
}

module.exports = {
  translateAPIError:   translateAPIError
};
